import { render, staticRenderFns } from "./DashboardLayoutView.vue?vue&type=template&id=739fd1d9&"
import script from "./DashboardLayoutView.vue?vue&type=script&lang=ts&"
export * from "./DashboardLayoutView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports